import React from "react";
import BusinessInterestEmpDashboard from "../component/BusinessInterestEmpDashboard";

const BusinessInterestEmpView = () => (
  <div>
    <BusinessInterestEmpDashboard />
  </div>
);

export default BusinessInterestEmpView;
